import { useEffect, useRef } from "react";
import { fetchProfile, onTermsRequired } from "@/lib/api";

// The app's answer when the server refuses an AI request (chat, voice,
// media) because the account hasn't accepted the current Kullanım Şartları
// — 403 terms_required, from any request (lib/api.js onTermsRequired):
// onRefused() runs at once (pages/Luna.jsx closes the call screen), then the
// profile is asked again and, while its terms still need accepting,
// onGate(profile) gets it — Luna.jsx shows TermsGate with it. Never an error
// toast (the callers skip theirs: lib/errorText.js isTermsRequired); once
// accepted the request can simply be sent again. One profile request at a
// time, however many requests were refused together.
export function useTermsRequired({ onRefused, onGate }) {
  const latest = useRef({ onRefused, onGate });
  latest.current = { onRefused, onGate };

  useEffect(() => {
    let alive = true;
    let checking = null;
    const off = onTermsRequired(() => {
      latest.current.onRefused?.();
      if (checking) return;
      checking = fetchProfile()
        .then((p) => {
          if (alive && p?.terms_current_version && p.terms_accepted_version !== p.terms_current_version) {
            latest.current.onGate?.(p);
          }
        })
        .catch(() => {}) // (the next refused request asks again)
        .finally(() => {
          checking = null;
        });
    });
    return () => {
      alive = false;
      off();
    };
  }, []);
}
